const assets = {
  images: {
    logo: require("./images/nav_logo.png"),
    smallLogo: require("./images/small_logo.png"),
  }
};

export default assets;